/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [tippy-config.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 13.11.18 17:11
 */
// original tippy
import Tippy, {roundArrow} from 'tippy.js';

import ReactDOMServer from 'react-dom/server';
import {showForceVisibleImages} from "./image-handler";

const NULL_CONTENT = '<div style="display:none">Loading...</div>';

export function showHtmlTooltip(elem, html, params) {
    const markup = ReactDOMServer.renderToStaticMarkup(html);
    return bindTooltip(elem, markup, params);
}

export function bindTooltip(elem, html, params) {
    const {
        callback = null,   // deprecated
        scrollbar = null,  // deprecated
        delay = [400, 0],
        trigger = 'mouseenter focus',
        animation = 'shift-toward',
        theme = 'standard',
        placement = 'bottom',
        showOnCreate = false,
        interactive = false,
        placeholderId
    } = params || {};

    Tippy(elem, {
        content: NULL_CONTENT,
        placement: placement,
        delay: delay,
        theme: theme,
        animation: animation,
        arrow: roundArrow,
        trigger: trigger,
        showOnCreate: showOnCreate,
        interactive: interactive,
        allowHTML: true,
        // popperOptions: {modifiers: {preventOverflow: {boundariesElement: 'window'}}},
        onShow(tooltip) {
            if (tooltip.loading || tooltip.showing) return;
            tooltip.loading = tooltip.showing = true;
            tooltip.setContent(html);
            tooltip.loading = false;

            // TODO remove and replace with simple-bar-scroller
            // scrollbar && setTimeout(() => {
            //     OverlayScrollbars(document.querySelector(scrollbar), {});
            // }, 1000);
            scrollbar && console.log('scrollbar is a performance no op');

        },
        onShown(tooltip) {
            showForceVisibleImages();
        },
        onHidden(tooltip) {
            tooltip.showing = false;
            tooltip.setContent(NULL_CONTENT);
        },
        // onClick: callback
    });

    return elem._tippy;
}


export function showTooltip(elem, params) {
    const {title, theme, placement, showOnCreate, trigger} = params || {};

    if (!title && !elem.getAttribute('title')) return;
    return Tippy(elem, {
        touch: 'hold',
        content: title || elem.getAttribute('title'),
        arrow: roundArrow,
        animation: 'shift-toward',
        placement: placement || 'top',
        showOnCreate: showOnCreate || false,
        allowHTML: true,
        trigger: trigger || 'mouseenter focus',
        theme: theme || "standard"
    });
}